import { RestaurantCheckout } from "./RestaurantCheckout";

export default RestaurantCheckout;
